<template>
  <div class="card" style="margin-bottom: 10px" ref="installedSalesComponent">
    <div class="card-body">
      <div class="row">
        <div class="col-8 col-sm-8 col-md-10 col-lg-10 col-xl-10">
          <p style="margin: 10px; font-weight: bold">
            <i style="margin-right: 10px" class="fas fa-list"></i> LISTADO DE
            VENTAS INSTALADAS
          </p>
        </div>
        <div
          class="col-4 col-sm-4 col-md-2 col-lg-2 col-xl-2"
          style="
            display: flex;
            gap: 1rem;
            justify-content: flex-end;
            align-items: center;
          "
        >
          <Skeletor
            v-if="loading"
            :shimmer="true"
            height="20"
            width="100%"
            style="margin: auto"
          />
          <template v-else>
            <div @click="refresh">
              <i
                style="cursor: pointer"
                class="fas fa-sync text-sm opacity-10"
              ></i>
            </div>
            <button
              @click="exportToExcel"
              class="btn btn-sm btn-excel"
              title="Exportar a Excel"
              :disabled="exportingExcel"
            >
              <i
                :class="exportingExcel ? 'fas fa-spinner fa-spin' : 'fas fa-file-excel'"
              ></i>
              Exportar Todo
            </button>
            <button
              @click="exportToExcelPreviousMonth"
              class="btn btn-sm btn-excel"
              title="Exportar a Excel"
              :disabled="exportingExcel"
            >
              <i
                :class="exportingExcel ? 'fas fa-spinner fa-spin' : 'fas fa-file-excel'"
              ></i>
              Exportar
              {{
                new Date(new Date().setMonth(new Date().getMonth() - 1))
                  .toLocaleString("es-ES", {
                    month: "long",
                    year: "numeric",
                  })
                  .replace(" de ", " ")
                  .replace(/^[a-z]/, (l) => l.toUpperCase())
              }}
            </button>
          </template>
        </div>
      </div>

      <!-- Filter Section -->
      <div v-if="!loading && !notAllow" class="row mb-3">
        <div class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
          <div class="form-group">
            <label for="companyFilter" class="form-label"
              >Filtrar por Distribuidor:</label
            >
            <select
              id="companyFilter"
              class="form-select"
              v-model="selectedCompany"
              @change="applyFilters"
            >
              <option value="all">Todos los distribuidores</option>
              <option
                v-for="company in companies"
                :key="company"
                :value="company"
              >
                {{ company }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div
        v-if="!loading && !notAllow"
        style="
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
          align-items: center;
          margin: 0 0 12px 0;
          font-size: 13px;
          color: #555;
        "
      >
        <span style="font-weight: 600">Leyenda:</span>
        <span style="display: inline-flex; align-items: center; gap: 6px">
          <i
            class="fas fa-building"
            style="color: #28a745; font-size: 1.1em"
          ></i>
          Empresa (Cadena de tiendas)
        </span>
        <span style="display: inline-flex; align-items: center; gap: 6px">
          <i
            class="fas fa-sitemap"
            style="color: #7d0c7e; font-size: 1.1em"
          ></i>
          Multinivel
        </span>
      </div>

      <div
        v-if="loading"
        class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        style="padding: 0px"
      >
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor :shimmer="true" height="40" width="50%" />
          </div>

          <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
            <Skeletor
              :shimmer="true"
              height="10"
              pill
              width="30%"
              style="margin-bottom: 10px"
            />
            <Skeletor :shimmer="true" height="40" width="100%" />
          </div>
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <table class="table tablesorter">
              <thead class="thead-light">
                <tr>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                  <th><Skeletor :shimmer="true" height="10" width="100%" /></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
                <tr>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                  <td><Skeletor :shimmer="true" height="20" width="100%" /></td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="col-6 col-sm-6 col-md-8 col-lg-8 col-xl-8">
            <Skeletor :shimmer="true" height="10" pill width="80%" />
          </div>

          <div class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4">
            <div class="row">
              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>

              <div
                class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4"
                align="center"
              >
                <Skeletor :shimmer="true" circle size="30" />
              </div>

              <div class="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4">
                <Skeletor :shimmer="true" height="10" width="100%" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else-if="notAllow" class="row">
        <div
          class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
          align="center"
        >
          <img style="width: 100px" src="/img/caution.svg" />

          <p style="margin-top: 10px; font-size: 14px">
            Tu rol no te permite utilizar la siguiente funcionalidad.
          </p>
        </div>
      </div>

      <DataTable
        v-else
        :columns="columns"
        :options="options"
        :data="filteredInstalledSales"
        class="table tablesorter"
        width="100%"
      >
        <thead>
          <tr>
            <th>Actualizado</th>
            <th>Registrado</th>
            <th>Promotor</th>
            <th>Celular</th>
            <th data-priority="1">Nombre</th>
            <!-- <th data-priority="2">Canal</th> -->
            <th data-priority="3">Distribuidor</th>
            <th># Cuenta</th>
            <th>Plan</th>
            <th>Precio</th>
            <th>Tipo</th>
            <th>Acciones</th>
            <th>Adelanto</th>
          </tr>
        </thead>
      </DataTable>
    </div>

    <!-- Edit Modal -->
    <VueFinalModal
      v-model="showEditModal"
      :esc-to-close="true"
      class="modal-container"
      content-class="modal-content4"
      @closed="closeEditModal"
    >
      <div class="modal__content">
        <div class="row">
          <div class="col-11 col-sm-11 col-md-11 col-xl-11 col-lg-11">
            <h4 class="modal-title">Editar Información</h4>
          </div>
          <div
            class="col-1 col-sm-1 col-md-1 col-xl-1 col-lg-1"
            @click="closeEditModal"
          >
            <i
              class="fas fa-times-square close_modal"
              style="color: slategray; cursor: pointer"
            ></i>
          </div>
        </div>

        <div v-if="selectedSale" class="row mt-3">
          <p><strong>Cliente:</strong> {{ selectedSale.displayName }}</p>
          <p><strong>Cédula:</strong> {{ selectedSale.dni }}</p>

          <div class="col-12 mb-3">
            <label for="accountNumber" class="form-label"
              >Número de Cuenta:</label
            >
            <input
              type="text"
              id="accountNumber"
              class="form-control"
              v-model="accountNumber"
              placeholder="Ingrese el número de cuenta"
            />
          </div>

          <div class="col-12 mb-3">
            <label for="planName" class="form-label">Nombre del Plan:</label>
            <input
              type="text"
              id="planName"
              class="form-control"
              v-model="planName"
              placeholder="Ingrese el nombre del plan"
            />
          </div>

          <div class="col-12 mb-3">
            <label for="planValue" class="form-label">Valor del Plan:</label>
            <input
              type="text"
              id="planValue"
              class="form-control"
              v-model="planValue"
              placeholder="Ingrese el valor del plan"
              @input="formatPlanValue"
              @blur="validatePlanValue"
            />
          </div>

          <div class="col-12 mb-3">
            <label for="saleType" class="form-label">Tipo de Venta:</label>
            <select id="saleType" class="form-select" v-model="saleType">
              <option value="internet">Internet</option>
              <option value="zapping">Zapping</option>
            </select>
            <small class="form-text text-muted">
              Zapping siempre paga 0.5 ARPU (mitad del valor). Internet usa la tabla del distribuidor.
            </small>
          </div>

          <div class="col-12 mb-3">
            <label for="updatedAt" class="form-label"
              >Fecha de Actualización:</label
            >
            <input
              type="datetime-local"
              id="updatedAt"
              class="form-control"
              v-model="updatedAt"
              placeholder="Seleccione la fecha de actualización"
            />
            <small class="form-text text-muted"
              >Si no se especifica, se usará la fecha actual</small
            >
          </div>

          <div class="col-12 text-center mt-3">
            <button
              class="btn btn-secondary me-2"
              @click="closeEditModal"
              :disabled="isSaving"
            >
              Cancelar
            </button>
            <button
              class="btn btn-primary"
              @click="saveChanges"
              :disabled="isSaving"
            >
              <i v-if="isSaving" class="fas fa-spinner fa-spin me-2"></i>
              {{ isSaving ? "Guardando..." : "Guardar Cambios" }}
            </button>
          </div>
        </div>
      </div>
    </VueFinalModal>
  </div>
</template>

<script>
/* eslint-disable */

import DataTable from "datatables.net-vue3";
import DataTablesCore from "datatables.net-bs5";
import "datatables.net-responsive";
import $ from "jquery";
import { VueFinalModal } from "vue-final-modal";
import "vue-final-modal/style.css";
DataTable.use(DataTablesCore);

export default {
  components: {
    DataTable,
    VueFinalModal,
  },
  props: ["userId", "tokenAuth", "role"],
  data() {
    return {
      loading: true,
      installedSales: [],
      allInstalledSales: [], // Store all sales for filtering
      notAllow: false,
      showEditModal: false,
      selectedSale: null,
      accountNumber: "",
      planName: "",
      planValue: "",
      saleType: "internet",
      updatedAt: "",
      isSaving: false,
      loadingPayment: {}, // Track payment loading state by saleId
      exportingExcel: false,
      selectedCompany: "all", // Default to show all companies
      companies: [], // Will store unique company names
      columns: [
        {
          data: null,
          render: function (data) {
            const date = new Date(
              data.updatedAt._seconds * 1000 +
                data.updatedAt._nanoseconds / 1e6,
            );
            return date.toLocaleString("es-ES", {
              timeZone: "America/Guayaquil",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            });
          },
        },
        {
          data: null,
          render: function (data) {
            const date = new Date(
              data.createdAt._seconds * 1000 +
                data.createdAt._nanoseconds / 1e6,
            );
            return date.toLocaleString("es-ES", {
              timeZone: "America/Guayaquil",
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
            });
          },
        },
        {
          data: null,
          render: function (data) {
            const promoterName = `${data.promoterNames} ${data.promoterLastnames}`;
            const isEnterprise = data.isEnterprise === true;
            let html = promoterName;
            if (isEnterprise) {
              html += ` <i class="fas fa-building" style="color: #28a745; margin-left: 5px; font-size: 1.1em;" title="Cadena de tiendas"></i>`;
            }
            if (data.identifiedByEmployeeCode === true) {
              const code = data.promoterEmployeeCode
                ? ` (${data.promoterEmployeeCode})`
                : "";
              html += ` <i class="fas fa-sitemap" style="color: #7d0c7e; margin-left: 5px; font-size: 1.1em;" title="Multinivel${code}"></i>`;
            }
            return html;
          },
        },
        { data: "phone" },
        {
          data: null,
          render: function (data) {
            return data.displayName;
          },
        },
        {
          data: "companyName",
        },
        {
          data: null,
          render: function (data) {
            return data.accountNumber || "No Disponible";
          },
        },
        {
          data: null,
          render: function (data) {
            return data.planName || "No Disponible";
          },
        },
        {
          data: null,
          render: function (data) {
            return data.planValue
              ? "$" + data.planValue.toFixed(2)
              : "No Disponible";
          },
        },
        {
          data: null,
          render: function (data) {
            const isZapping = data.saleType === "zapping";
            const label = isZapping ? "Zapping" : "Internet";
            const badgeClass = isZapping ? "bg-info" : "bg-primary";
            return `<span class="badge ${badgeClass}" style="font-size: 11px;">${label}</span>`;
          },
        },
        {
          data: null,
          render: (data, type, row) => {
            return !data.paidArpu
              ? `<button style="display: flex; justify-content: center; align-items: center; gap: 4px;" onclick="window.openEditModal('${row.id}', '${data.saleId}')" data-planid="${data.saleId}" class="btn btn-primary"><i class="fas fa-edit"></i> Editar</button>`
              : "No Disponible";
          },
        },
        {
          data: null,
          render: function (data, type, row) {
            console.log("data", data);
            console.log("planValue", data.planValue);
            const isEnterprise = data.isEnterprise === true;
            return data.planValue
              ? data.paidArpu
                ? "$" + data.paidArpuAmount.toFixed(2)
                : isEnterprise
                  ? "N/A"
                  : `<button class="btn btn-primary" style="text-wrap: nowrap;" id="pay-button-${data.saleId}" onclick="window.openPaidArpuModal('${row.id}', '${data.saleId}', ${data.planValue}, '${data.companyName}')" data-saleid="${data.saleId}">Pagar</button>`
              : "No Disponible";
          },
        },
      ],
      options: {
        responsive: true,
        ordering: false,
        columnDefs: [
          { responsivePriority: 1, targets: 0 },
          { responsivePriority: 2, targets: -1 },
        ],
        lengthMenu: [
          [7, 15, 25, 35, 50, -1],
          [7, 15, 25, 35, 50, "All"],
        ],
        pageLength: 7,
        language: {
          search: "Buscar:",
          sInfo:
            "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          sInfoEmpty:
            "Mostrando registros del 0 al 0 de un total de 0 registros",
          searchPlaceholder: "Buscar por término...",
          zeroRecords: "Lo sentimos, no se encontraron resultados",
          processing: "Buscando. Espere por favor...",
          sLengthMenu: "Mostrar _MENU_ registros",
          oPaginate: {
            sFirst: "Primero",
            sLast: "Último",
            sNext: "Siguiente",
            sPrevious: "Anterior",
          },
          infoFiltered: " - filtrados de _MAX_ registros",
        },
      },
    };
  },
  computed: {
    // Filter installed sales based on selected company
    filteredInstalledSales() {
      if (this.selectedCompany === "all") {
        return this.installedSales;
      } else {
        return this.installedSales.filter(
          (sale) => sale.companyName === this.selectedCompany,
        );
      }
    },
  },
  watch: {
    // When installed sales data changes, extract companies for the filter
    installedSales: {
      handler(newSales) {
        this.extractCompanies();
      },
      deep: true,
    },
    // Watch for modal state changes to reset fields when modal is closed
    showEditModal(newVal) {
      if (!newVal) {
        // Modal was closed, reset the form fields
        this.$nextTick(() => {
          this.resetFormFields();
        });
      }
    },
  },
  mounted() {
    this.getListado();

    // Create a global window function to bridge between the rendered HTML and Vue
    window.openEditModal = (id, saleId) => {
      this.openEditModal(id, saleId);
    };

    window.openPaidArpuModal = (id, saleId, planValue, companyName) => {
      this.openPaidArpuModal(id, saleId, planValue, companyName);
    };
  },
  beforeUnmount() {
    // Clean up global function when component is unmounted
    delete window.openEditModal;
    delete window.openPaidArpuModal;
  },
  methods: {
    refresh() {
      $(document).off("click", ".consultar");
      this.$eventBus.emit("reiniciarListadoVentasInstaladasAdmin");
    },

    // Apply filters when dropdown selection changes
    applyFilters() {
      // The actual filtering is done in the computed property
      // This method can be extended for additional functionality if needed
      console.log("Filter applied: ", this.selectedCompany);
    },

    // Extract unique company names for the dropdown
    extractCompanies() {
      const companiesSet = new Set();

      this.installedSales.forEach((sale) => {
        if (sale.companyName) {
          companiesSet.add(sale.companyName);
        }
      });

      // Convert to array and sort alphabetically
      this.companies = Array.from(companiesSet).sort((a, b) =>
        a.localeCompare(b, undefined, { sensitivity: "base" }),
      );

      console.log("Extracted companies:", this.companies);
    },

    formatPlanValue() {
      // Replace commas with decimal points
      this.planValue = this.planValue.replace(/,/g, ".");

      // Remove any non-numeric characters except decimal point
      this.planValue = this.planValue.replace(/[^\d.]/g, "");

      // Ensure only one decimal point
      const parts = this.planValue.split(".");
      if (parts.length > 2) {
        this.planValue = parts[0] + "." + parts.slice(1).join("");
      }

      // Limit to 2 decimal places if there's a decimal point
      if (this.planValue.includes(".")) {
        const [whole, decimal] = this.planValue.split(".");
        this.planValue = whole + "." + decimal.substring(0, 2);
      }
    },

    validatePlanValue() {
      if (this.planValue) {
        // Format to 2 decimal places when leaving the field
        const value = parseFloat(this.planValue);
        if (!isNaN(value)) {
          this.planValue = value.toFixed(2);
        }
      }
    },

    getListado() {
      this.$https
        .post("/administration/fetchInstalledSales", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
        })
        .then((response) => {
          this.loading = false;
          this.notAllow = false;
          this.installedSales = response.data.installedSales;
          this.allInstalledSales = [...response.data.installedSales]; // Keep a copy of all sales
          this.extractCompanies(); // Extract unique companies for the filter dropdown
        })
        .catch((error) => {
          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.loading = false;
            this.notAllow = false;
            this.$router.push({ name: "Signin" });
          } else if (error.status === 403) {
            this.loading = false;
            this.$router.push({ name: "Dashboard" });
            this.$toast.error("Acceso no autorizado", {
              position: "top-right",
              max: 10,
            });
          } else {
            this.$toast.error("Ocurrió un error inesperado", {
              position: "top-right",
              max: 10,
            });
            this.loading = false;
            this.notAllow = true;
          }

          // this.getListado();
        });
    },

    async downloadInstalledSalesExcel(mode) {
      if (this.exportingExcel) return;
      this.exportingExcel = true;

      try {
        const response = await this.$https.post(
          "/administration/exportInstalledSalesExcel",
          {
            tokenAuth: this.tokenAuth,
            userId: this.userId,
            mode,
            companyFilter: this.selectedCompany,
          },
          { responseType: "blob" },
        );

        const disposition = response.headers["content-disposition"] || "";
        const match = disposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
        let fileName = "Ventas_Instaladas.xlsx";
        if (match && match[1]) {
          fileName = decodeURIComponent(match[1].replace(/['"]/g, ""));
        }

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$toast.success("Archivo Excel generado correctamente", {
          position: "top-right",
          max: 10,
        });
      } catch (error) {
        if (error.response?.data instanceof Blob) {
          const text = await error.response.data.text();
          try {
            const json = JSON.parse(text);
            this.$toast.info(json.message || "No hay ventas para exportar", {
              position: "top-right",
              max: 10,
            });
          } catch {
            this.$toast.error("Error al generar el archivo Excel", {
              position: "top-right",
              max: 10,
            });
          }
        } else {
          this.$toast.error(
            error.response?.data?.message || "Error al generar el archivo Excel",
            { position: "top-right", max: 10 },
          );
        }
      } finally {
        this.exportingExcel = false;
      }
    },

    exportToExcel() {
      this.downloadInstalledSalesExcel("all");
    },

    exportToExcelPreviousMonth() {
      this.downloadInstalledSalesExcel("previous_month");
    },

    openEditModal(rowId, saleId) {
      // Use saleId to find the correct sale record
      const sale = this.installedSales.find((sale) => sale.saleId === saleId);
      if (sale) {
        this.selectedSale = sale;
        this.accountNumber = sale.accountNumber || "";
        this.planName = sale.planName || "";
        this.planValue = sale.planValue || "";
        this.saleType = sale.saleType === "zapping" ? "zapping" : "internet";

        // Initialize updatedAt field with current updatedAt date
        if (sale.updatedAt) {
          let date;
          if (sale.updatedAt._seconds) {
            date = new Date(
              sale.updatedAt._seconds * 1000 +
                (sale.updatedAt._nanoseconds || 0) / 1e6,
            );
          } else if (sale.updatedAt instanceof Date) {
            date = sale.updatedAt;
          } else if (sale.updatedAt.toDate) {
            date = sale.updatedAt.toDate();
          } else {
            date = new Date();
          }

          // Format date for datetime-local input (YYYY-MM-DDTHH:mm)
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0");
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          this.updatedAt = `${year}-${month}-${day}T${hours}:${minutes}`;
        } else {
          this.updatedAt = "";
        }

        this.showEditModal = true;
      } else {
        console.error("Sale not found with saleId:", saleId);
      }
    },

    openPaidArpuModal(rowId, saleId, planValue, companyName) {
      console.log("rowId", rowId);
      console.log("saleId", saleId);
      console.log("planValue", planValue);
      console.log("companyName", companyName);
      // Convert planValue to a number and format it
      const formattedPlanValue = parseFloat(planValue).toFixed(2);

      this.$swal({
        title: `¿Estás seguro que quieres pagar el adelanto de la venta al distribuidor ${companyName}?`,
        text: "El adelanto es de $" + formattedPlanValue,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Pagar",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-secondary ml-1",
        },
        backdrop: true,
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          this.paidArpu(saleId);
        }
      });
    },

    closeEditModal() {
      this.showEditModal = false;
      this.resetFormFields();
    },

    resetFormFields() {
      this.accountNumber = "";
      this.planName = "";
      this.planValue = "";
      this.saleType = "internet";
      this.updatedAt = "";
      this.selectedSale = null;
      this.isSaving = false;
    },

    saveChanges() {
      if (!this.selectedSale) return;

      this.isSaving = true;

      // Prepare updatedAt date if provided
      let updatedAtDate = null;
      if (this.updatedAt) {
        updatedAtDate = new Date(this.updatedAt);
      }

      this.$https
        .post("/administration/updateSaleData", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          saleId: this.selectedSale.saleId,
          accountNumber: this.accountNumber,
          planName: this.planName,
          planValue: this.planValue,
          saleType: this.saleType,
          updatedAt: updatedAtDate ? updatedAtDate.toISOString() : null,
        })
        .then((response) => {
          this.isSaving = false;

          this.$toast.success("Información actualizada correctamente", {
            position: "top-right",
            max: 10,
          });

          this.resetFormFields();
          this.showEditModal = false;
          this.getListado();
        })
        .catch((error) => {
          this.isSaving = false;

          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else {
            this.$toast.error(
              error.data?.message || "No se pudo actualizar la información",
              {
                position: "top-right",
                max: 10,
              },
            );
          }
        });
    },

    paidArpu(saleId) {
      if (!saleId) {
        this.$toast.error("ID de venta no válido", {
          position: "top-right",
          max: 10,
        });
        return;
      }

      // Set loading state for this specific payment button
      this.loadingPayment = { ...this.loadingPayment, [saleId]: true };

      // Update the button to show loading state
      const payButton = document.getElementById(`pay-button-${saleId}`);
      if (payButton) {
        payButton.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
        payButton.disabled = true;
      }

      this.$https
        .post("/administration/paidArpu", {
          tokenAuth: this.tokenAuth,
          userId: this.userId,
          saleId: saleId,
        })
        .then((response) => {
          // Clear loading state
          this.loadingPayment = { ...this.loadingPayment, [saleId]: false };

          this.$toast.success("Adelanto pagado correctamente", {
            position: "top-right",
            max: 10,
          });
          this.getListado(); // Refresh the list
        })
        .catch((error) => {
          // Clear loading state
          this.loadingPayment = { ...this.loadingPayment, [saleId]: false };

          // Reset button state if there's an error
          if (payButton) {
            payButton.innerHTML = "Pagar";
            payButton.disabled = false;
          }

          if (error.status === 401) {
            this.$store.dispatch("clearAllData");
            this.$toast.error("Sesión expirada. Inicie sesión nuevamente", {
              position: "top-right",
              max: 10,
            });
            this.$router.push({ name: "Signin" });
          } else {
            this.$toast.error(
              error.response.data?.message || "No se pudo procesar el pago",
              {
                position: "top-right",
                max: 10,
              },
            );
          }
        });
    },
  },
};
</script>

<style lang="scss">
@import "datatables.net-dt";
@import "datatables.net-responsive-dt";

.modal-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-content {
  display: flex;
  flex-direction: column;
  margin: 0 1rem;
  padding: 1rem;
  border: 1px solid #e2e8f0;
  border-radius: 0.25rem;
  background: #fff;
  max-width: 500px;
  width: 100%;
}

.modal__content {
  padding: 1rem;
}

.modal-title {
  font-size: 1.25rem;
  font-weight: 600;
  color: #4a5568;
  margin-bottom: 0.5rem;
}

.close_modal {
  font-size: 1.5rem;
  cursor: pointer;
}

.btn-excel {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  background-color: #28a745 !important;
  color: white !important;
  border: none !important;
  text-wrap: nowrap;
}

.btn-excel:hover {
  background-color: #218838 !important;
}
</style>
